/*
|--------------------------------------------------------------------------
| SkinCentrick Country Switch
|--------------------------------------------------------------------------
| India  -> skincentrick.in
| Others -> skincentrick.com
|--------------------------------------------------------------------------
*/

const STORE_MAP = {
  IN: "https://skincentrick.in",

  BR: "https://skincentrick.com",
  CA: "https://skincentrick.com",
  CL: "https://skincentrick.com",
  DE: "https://skincentrick.com", // Europe
  MX: "https://skincentrick.com",
  PE: "https://skincentrick.com",
  SA: "https://skincentrick.com",
  AE: "https://skincentrick.com",
  US: "https://skincentrick.com"
};

/*
|--------------------------------------------------------------------------
| Select Country
|--------------------------------------------------------------------------
*/

function selectCountryHeader(countryCode, formId) {

    countryCode = countryCode.toUpperCase();

    const form = document.getElementById(formId);

    if (!form) return;

    const input = form.querySelector('input[name="country_code"]');

    if (!input) return;

    input.value = countryCode;

    // Reset the "Remember my choice" popup preference when switching to India
    if (countryCode === 'IN') {
        localStorage.removeItem("preferredStore");
    }

    const currentStore =
        window.location.origin;

    const targetStore =
        STORE_MAP[countryCode] || "https://skincentrick.com";

    const path =
        window.location.pathname +
        window.location.search +
        window.location.hash;

    /*
    |--------------------------------------------------------------------------
    | Different Shopify Store
    |--------------------------------------------------------------------------
    */

    // If switching to India from the .com store
    if (countryCode === 'IN' && !window.location.hostname.includes('.in')) {
        window.location.href = "https://skincentrick.in" + path;
        return;
    }

    // If switching to Global/US/MX from the .in store
    if (countryCode !== 'IN' && window.location.hostname.includes('.in')) {
        const separator = path.includes('?') ? '&' : '?';
        window.location.href = "https://skincentrick.com" + path + separator + "set_country=" + countryCode;
        return;
    }

    /*
    |--------------------------------------------------------------------------
    | Same Store
    |--------------------------------------------------------------------------
    */

    form.submit();

}


/*
|--------------------------------------------------------------------------
| Desktop Dropdown
|--------------------------------------------------------------------------
*/

function toggleDesktopCountryMenu() {

    const menu =
        document.getElementById("desktop-country-menu");

    if (!menu) return;

    document
        .querySelectorAll(".sc-country-menu")
        .forEach(function(item) {

            if (item !== menu) {
                item.classList.remove("open");
            }

        });

    menu.classList.toggle("open");

}


/*
|--------------------------------------------------------------------------
| Close Dropdown
|--------------------------------------------------------------------------
*/

document.addEventListener("click", function(event) {

    if (!event.target.closest(".sc-country-desktop")) {

        document
            .querySelectorAll(".sc-country-menu")
            .forEach(function(menu) {

                menu.classList.remove("open");

            });

    }

});


/*
|--------------------------------------------------------------------------
| ESC closes dropdown
|--------------------------------------------------------------------------
*/

document.addEventListener("keydown", function(event){

    if(event.key !== "Escape") return;

    document
        .querySelectorAll(".sc-country-menu")
        .forEach(function(menu){

            menu.classList.remove("open");

        });

});


/*
|--------------------------------------------------------------------------
| Future Expansion
|--------------------------------------------------------------------------
|

Just update STORE_MAP.

Example:

STORE_MAP = {

    IN : "https://skincentrick.in",

    CA : "https://skincentrick.ca",

    AE : "https://skincentrick.ae",

    US : "https://skincentrick.com",

    ...

}

No other code changes required.

|--------------------------------------------------------------------------
*/

document.addEventListener("DOMContentLoaded", function() {
    const params = new URLSearchParams(window.location.search);
    const setCountryCode = params.get('set_country');
    if (setCountryCode) {
        // Clean URL immediately
        params.delete('set_country');
        const newSearch = params.toString();
        const newUrl = window.location.pathname + (newSearch ? "?" + newSearch : "") + window.location.hash;
        window.history.replaceState({}, document.title, newUrl);
        
        // Find a valid Shopify localization form and submit the new country
        const form = document.getElementById('CountryFormDesktop') || document.getElementById('CountryFormMobile');
        if (form) {
            const input = form.querySelector('input[name="country_code"]');
            if (input) {
                input.value = setCountryCode.toUpperCase();
                form.submit();
            }
        }
    }
});